import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Carousel3d from 'vue-carousel-3d'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {environmentConfig} from "./config/environmentConfig";

Vue.config.productionTip = false;
Vue.prototype.$environmentConfig = environmentConfig;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Carousel3d);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

Array.prototype.asyncForEach = async function(callback, thisArg) {
  thisArg = thisArg || this;
  for (let i = 0, l = this.length; i !== l; ++i) {
    await callback.call(thisArg, this[i], i, this)
  }
};
